var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Auth',{attrs:{"auth":_vm.auth},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('i',_vm._g(_vm._b({},'i',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)]},proxy:true}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }